module.exports = __webpack_public_path__ + "static/media/md-happy.1766c2c3.svg";